import { Breath, Discount, Footer } from "../components";

const Sales = () => {
  return (
    <>
      <Discount />
      <Breath />
      <Footer />
    </>
  );
};

export default Sales;
